<template>
  <v-footer
      color="#292929"
      height="100"
    >

        <v-container class="pa-0 expanded">
            <v-row align="center">
                <v-col md="4" class="ma-0 pa-0">
                    <a href="https://www.uniservices.co.nz/">
                        <v-img :src="getLogo()" height="80" contain></v-img>
                    </a>
                </v-col>
                <v-col md="4">
                    <div class="title font-weight-light grey--text text--lighten-1 text-center">
                        &copy; {{ (new Date()).getFullYear() }} — <router-link to="/">Subvox</router-link>
                    </div>
                </v-col>
                <v-col md="4" >
                    <div class="title font-weight-light grey--text text--lighten-1 text-center">
                        <a href="" @click.prevent="$emit('showLegalDialog')">Legal & Privacy Terms</a>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>


<script>
  export default {
    name: 'Footer',

    data: () => ({
    }),
    methods: {
        getLogo() {
            return this.getHost() + "/content/footer_logo.png";
        }
    }
  }
</script>

<style scoped>
    .expanded {
      max-width: none;
    }
</style>
